export default __webpack_public_path__ + "static/media/18.b9254ecc.png";